import React, { useState, useEffect } from 'react';

const OfferBanner = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentOfferIndex, setCurrentOfferIndex] = useState(0);

  useEffect(() => {
    fetchOffers();
  }, []);

  useEffect(() => {
    if (offers.length > 1) {
      const interval = setInterval(() => {
        setCurrentOfferIndex((prevIndex) => (prevIndex + 1) % offers.length);
      }, 5000); // Change offer every 5 seconds

      return () => clearInterval(interval);
    }
  }, [offers.length]);

  const fetchOffers = async () => {
    try {
      console.log('Fetching offers from API...');
      const response = await fetch('http://127.0.0.1:8000/api/offers/active', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });
      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('API response:', data);
      if (data.success) {
        setOffers(data.data);
        console.log('Offers set:', data.data);
      } else {
        console.log('API response not successful');
        setError('API response not successful');
      }
    } catch (error) {
      console.error('Error fetching offers:', error);
      setError('Failed to load offers: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatTimeRemaining = (endDate) => {
    const now = new Date();
    const end = new Date(endDate);
    const diff = end - now;

    if (diff <= 0) return 'Expired';

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    if (days > 0) {
      return `${days}d ${hours}h left`;
    } else if (hours > 0) {
      return `${hours}h left`;
    } else {
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      return `${minutes}m left`;
    }
  };

  if (loading) {
    return (
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-2">
        <div className="container mx-auto px-4">
          <div className="text-center text-sm">
            <div className="animate-pulse">🎉 Loading amazing offers...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error || offers.length === 0) {
    return null; // Don't show banner if no offers or error
  }

  // For mobile/small screens, show a single rotating offer
  // For larger screens, show scrolling marquee
  const currentOffer = offers[currentOfferIndex];

  return (
    <>
      {/* Mobile/Tablet View - Single rotating offer */}
      <div className="md:hidden bg-gradient-to-r from-red-500 via-pink-500 to-purple-600 text-white py-2 px-4 overflow-hidden offer-banner">
        <div className="flex items-center justify-center space-x-3 text-center">
          <span className="text-lg">🎉</span>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-bold truncate">{currentOffer.title}</div>
            <div className="flex items-center justify-center space-x-2 text-xs">
              <span className="bg-white text-red-600 px-2 py-0.5 rounded-full font-bold offer-badge">
                {currentOffer.discount_display}
              </span>
              <span className="opacity-90">
                {formatTimeRemaining(currentOffer.end_date)}
              </span>
            </div>
          </div>
          <span className="text-lg">✨</span>
        </div>
        
        {/* Dots indicator for multiple offers */}
        {offers.length > 1 && (
          <div className="flex justify-center space-x-1 mt-1">
            {offers.map((_, index) => (
              <div
                key={index}
                className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                  index === currentOfferIndex ? 'bg-white' : 'bg-white bg-opacity-50'
                }`}
              />
            ))}
          </div>
        )}
      </div>

      {/* Desktop View - Scrolling marquee */}
      <div className="hidden md:block bg-gradient-to-r from-red-500 via-pink-500 to-purple-600 text-white py-3 overflow-hidden relative offer-banner">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative z-10">
          <div className="whitespace-nowrap animate-marquee">
            <div className="inline-flex items-center space-x-8">
              {offers.concat(offers).map((offer, index) => (
                <div key={`${offer.id}-${index}`} className="inline-flex items-center space-x-4 px-6">
                  <span className="text-2xl">🎉</span>
                  <div className="flex items-center space-x-3">
                    <span className="font-bold text-lg">{offer.title}</span>
                    <span className="bg-white text-red-600 px-3 py-1 rounded-full text-sm font-bold shadow-lg offer-badge">
                      {offer.discount_display}
                    </span>
                    <span className="text-sm opacity-90 bg-black bg-opacity-30 px-2 py-1 rounded">
                      ⏰ {formatTimeRemaining(offer.end_date)}
                    </span>
                    {offer.category && (
                      <span className="text-xs bg-white bg-opacity-20 px-2 py-1 rounded">
                        {offer.category}
                      </span>
                    )}
                  </div>
                  <span className="text-2xl">✨</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/* Gradient overlays for smooth fade effect */}
        <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-red-500 to-transparent z-20"></div>
        <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-purple-600 to-transparent z-20"></div>
      </div>
    </>
  );
};

export default OfferBanner;
